import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import { TextAreaWidget } from "Components/optionForm";
import { themeVariables } from "Components/theme";
import WithModal from "Components/withModal";
import join from "lodash/join";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import locale from "./modelErrorsPanel.locale";
export const SIZES = {
    MODAL_DEFAULT_WIDTH: 800,
    MODAL_DEFAULT_HEIGHT: `calc(100vh - ${parseInt(themeVariables["panel-body-padding"]) * 5}px)`
};
function ModelErrorsPanel(props) {
    const [open, setOpen] = useState(props.open);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);
    const handleClose = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    const modalContent = useMemo(() => (React.createElement("div", null,
        React.createElement(TextAreaWidget, { value: join(props.errors, "\r\n\r\n"), autoResizeEnabled: false, maxHeight: "100%", height: "100%", readOnly: true }))), [props.errors]);
    return (React.createElement(WithModal, { show: open, onHide: handleClose, contentClassName: "panel-body-pr panel-body-pb panel-body-pl pt-0_5", shadingColor: shadingLightestColor, className: "bg-blur", title: locale.ERRORS, defaultWidth: SIZES.MODAL_DEFAULT_WIDTH, defaultHeight: SIZES.MODAL_DEFAULT_HEIGHT }, modalContent));
}
export default memo(ModelErrorsPanel);
